import { Input } from '@neo/primitives/input'
import { Textarea } from '@neo/primitives/textarea'
import type z from 'zod'
import type { Intent } from '../../types'

export const IntentForm = ({
  value,
  onChange,
  hasDuplicateIntentName,
}: {
  value: Intent
  onChange: (value: Intent) => void
  hasDuplicateIntentName: z.IssueData
}) => {
  const isDuplicateIntentName = hasDuplicateIntentName?.path?.includes(
    value.intent_name?.trim() || '',
  )
  return (
    <div className="w-full max-w-2xl mx-auto mt-4">
      <div className="relative rounded-lg border p-4">
        <div className="space-y-4">
          <Input
            value={value.intent_name}
            label="Intent Name"
            placeholder="Intent name"
            className={`gap-2 leading-[unset] ${isDuplicateIntentName ? '' : ''}`}
            errorText={isDuplicateIntentName ? 'Intent name already exists' : undefined}
            onChange={(e) => onChange({ ...value, intent_name: e.target.value })}
          />
          <Textarea
            value={value.intent_instructions}
            label="When should this intent be used"
            className="bg-background min-h-[100px] max-h-[300px] overflow-y-auto"
            placeholder="Describe the scenarios or customer queries where this intent should be selected. For example: When the customer inquires about order cancellations."
            onChange={(e) => onChange({ ...value, intent_instructions: e.target.value })}
            autoExpand
          />
        </div>
      </div>
    </div>
  )
}
